import(/* webpackMode: "eager" */ "/app/src/app/earn-credits/billing/pricing-table/page.tsx");
